$(function(){
  $('.collection .card--media .card__inner .card__content').each(function () {
    const badgeText = $(this).find('.card__badge .badge').text().trim();

    if (badgeText === '売り切れ') {
      $(this).addClass('soldOut');
    }
  });
});